import { Link, useFetcher } from "@remix-run/react";
import { Megaphone, X } from "lucide-react";
import { useState } from "react";
import { Button } from "#app/components/ui/button.tsx";
import { Card, CardContent } from "#app/components/ui/card.tsx";

export default function AdPlaceholder() {
  const fetcher = useFetcher();

  return (
    <Card className="relative w-full bg-gradient-to-r from-gray-50 via-gray-100 to-gray-50 border border-gray-20 hover:border-gray-30 transition-all duration-50 shadow-sm hover:shadow-md">
      <fetcher.Form method="post" action="/resources/hide-ad">
        <button
          type="submit"
          className="absolute top-1 right-1 p-0.5 rounded-full bg-primary/10 hover:bg-primary/20 transition-colors duration-50 border border-primary/20"
          aria-label="Close advertisement"
        >
          <X className="w-4 h-4 text-primary" />
        </button>
      </fetcher.Form>
      <Link to="/anunciar-empresa" prefetch="intent">
        <CardContent className="flex items-center justify-between p-3">
          <div className="flex items-center gap-3">
            <div className="bg-gray-300 w-10 h-10 shrink-0 rounded-full flex items-center justify-center shadow-inner">
              <Megaphone className="w-5 h-5 text-primary" />
            </div>
            <div>
              <h3 className="font-semibold text-primary text-sm">
                Anuncie aqui
              </h3>
              <p className="text-xs text-muted-foreground line-clamp-2">
                Alcance milhares de proprietários de EVs
              </p>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            className="text-primary max-w-fit mr-4 ml-4 shrink-0 border-primary"
          >
            Anunciar
          </Button>
        </CardContent>
      </Link>
    </Card>
  );
}
